import { commonUrl, stoleBuilderHostUrl } from '../Utils/StaticURLs';

export const URL = {
    STOLE: {
        META: `${commonUrl}/StoleMeta.json`,
        ASSET_GROUPS: `${commonUrl}/CollegeStoleAssetGroups.json`,
        ASSET: (customerNumber) => `${stoleBuilderHostUrl}/stoleAsset?customerNumber=${customerNumber}`,
        CUSTOMER_PRODUCTS: (customerNumber) => `${stoleBuilderHostUrl}/customerProducts?customerNum=${customerNumber}`,
    },
};